export class PaymentMethod {
    constructor() {
        this.label = '';
        this.payMethod = '';
        this.currency = '';
        this.declarations = [];
        this.forms = [];
    }
  
    label: string;
    payMethod: string;
    currency: string;
    declarations: Array<PaymentMethodDeclaration>;
    forms: Array<PaymentMethodForm>;
}

export class PaymentMethodDeclaration {
    constructor() {
        this.decId = '';
    }

    decId: string;
}

export class PaymentMethodForm {
    constructor() {
        this.formId = '';
    }

    formId: string;
}